import type { Player } from '@dicetechnology/doris-core';

export const configureYospaceSsaiPlugin = async (player: Player, withV5: boolean): Promise<void> => {
    const YOSPACE_SSAI_PLUGIN_NAME = 'yospace-ssai';

    const shouldUseYospaceSsaiPlugin = !withV5;
    if (!shouldUseYospaceSsaiPlugin) {
        return;
    }

    const { YospaceSsaiPlugin } = await import('@dicetechnology/doris-plugin-yospace-ssai');

    const existingPlugin = player.getPluginByType(YospaceSsaiPlugin);
    if (!existingPlugin) {
        player.addPlugin({
            name: YOSPACE_SSAI_PLUGIN_NAME,
            Plugin: YospaceSsaiPlugin
        });
    }
};
